var app = app || {};

app.quicklinks = (function ($) {

    /***
    * applyFoldedMenu()
    * Apply a class to the menu on timeout.
    *
    * @ element.        The element to apply the folded rules to.
    * @ className.      The name of the class we're using to control our folded behaviours.
    * @ timeout.        Specify the timeout for the event.
    ***/
    var applyFoldedMenu = function(element, className, timeout){

        // Check to see if timout is undefined  , if it is then set a deafult timeout.
        timeout = typeof timeout !== 'undefined' ?  timeout : 3000;

        // if the class name already exists, no need to continue.
        if(!element.hasClass(className)){
            // Apply the class when the specified timeout is reached.
            setTimeout(function(){
                element.addClass(className);
            }, timeout);
        }
    };



    /***
    * applyViewportSticky()
    * A simple function that revokes any of the applied sticky rules to the specified element.
    *
    * @ element.        The elelment to revoke the sticky rules from.
    * @ offset.         The offset from the top of the browser window.
    * @ className.      The name of the class we're using to control our sticky behaviours.
    ***/
    applyViewportSticky = function(element, offset, className){

        if(!element.hasClass(className)){
            element.addClass(className);
        }
    },



    /***
    * dropViewportSticky()
    * A simple function that revokes any of the applied sticky rules to the specified element.
    *
    * @ element.    The elelment to revoke the sticky rules from.
    * @ className.  The name of the class we're using to control our sticky behaviours.
    ***/
    dropViewportSticky = function(element, className){

            // If the specified class name is set then remove it back to default.
            if(element.hasClass(className)){
                element.removeClass(className);
            }

            
            // Drop the style attribute altogehter so the sticky rules that's set doesn't affect any default CSS.
            element.removeAttr('style');
    },



    /***
    * elementExists()
    * A simple 'check if element exists' function. This is a shorthand version of the if (element.length > 0) check. Return true if query is found.
    *
    * @ element.    The element to query.
    * @ return - true (bool)
    ***/
    elementExists = function(element){
        return(element.length > 0);
    },



    /***
    * isVisible()
    * A simple 'check if element is visible' (i.e not display: none) function. This is a shorthand function that returns a bool if query has a result.
    *
    * @ element.    The element to query.
    * @ return - true (bool)
    ***/
    isVisible = function(element){

        // First run it through elementExists() to see if the element exists.
        if(elementExists(element)){
            
            // Return true if visible returns a value greater than 0 (0 being the default if no result found).
            return (element.filter(':visible').length > 0);                
        }
    },



    /***
    * dropViewportSticky()
    * A simple function that revokes any of the applied sticky rules to the specified element.  
    *
    * @ element.    The elelment to revoke the sticky rules from.
    * @ className.  The name of the class we're using to control our sticky behaviours.
    ***/
    persistantStickyWhenVisible = function(){

        // Declare the element we want to make sticky.
        var stickyElement = $('.quicklinks');


        // Check that the sticky element exists before continuing.
        if(elementExists(stickyElement)){

            // Store the active browser dimensions...
            var documentTopPoint = $(document).scrollTop(); // Store the top point of the document.
                viewportHeight = $(window).height(), // Height of the viewport.
                viewportMiddlePoint = Math.round(viewportHeight / 2); // half the hieght and round off to make it easier for the DOM to handle the pixels.


            // Set the element that we want to apply the sticky bahviours too.
            var stickyElement = $('.quicklinks'),
                stickyPosition = stickyElement.offset().top; // Store the top point of the sticky from the top of the document.
                stickyHeight = stickyElement.outerHeight(),
                stickyHalfHeight =  (stickyHeight / 2),
                stickyEnabled = false, // Use a simple bool to tell us the state of the sticky.
                anchorPoint = 0; // Set an anchor point to distiguish when we need to pick up and drop-off the sticky element.


            // Calculate the position of the element by taking of the height of the viewport height.
            var anchorIn = (stickyElement.offset().top - documentTopPoint + stickyElement.height());    


            ///////
            // Step 1: On Page Load, if we're below the anchor point, apply the sticky by default.
            ///////
            
            // Is sticky enabled? (it shouldn't be at this point but it seems to make sense to do a precautionary check first).
            // Also, is the sticky element visible? (n'b it maybe hidden on mobile etc)
            if(!stickyEnabled && isVisible(stickyElement)){

                // As the postion of the sticky element reaches (and passes) the centre of the viewport height, apply the sticky to retian it's position.
                if(anchorIn <= viewportMiddlePoint){
                        

                        // Apply the sticky at the view port middle point.
                        applyViewportSticky(stickyElement, viewportMiddlePoint, 'persistent');      

                        // Trigger the stickyEnabled bool.
                        stickyEnabled = true;
                        anchorPoint = Math.round(viewportMiddlePoint + (stickyHalfHeight));



                } 

                if((stickyPosition + stickyHeight) < (viewportHeight + documentTopPoint)){
                    applyFoldedMenu(stickyElement, 'folded');
                }
            }       




            ///////
            // Step 2: If the browser is re-sized, adjust the dimensions and re-apply the viewport sticky appropriately.
            ////

            // Use onResize wrapper to reset the viewport height as it's adjusted.
            $(window).on("debouncedresize", function( event ) {

                // Reset the full and half veiwport heights to the new dimensions.
                viewportHeight = $(window).height(),  
                viewportMiddlePoint = (viewportHeight / 2);
                documentTopPoint = $(document).scrollTop();


                // In the resize has out anchorPoint fallen below the new viewport middle point? If so reset the anchor point to the vp-m.
                if(anchorPoint < viewportMiddlePoint){
                    anchorPoint = viewportMiddlePoint;
                }


                // If the sticky element is visible and stiky is not enabled...
                if(isVisible(stickyElement) && !stickyEnabled){

                    // Also... if the re-calculated documnet top point is greater than the viewport middle then let's reshuffle our sticky position.
                    if(documentTopPoint >= viewportMiddlePoint){

                        // Adjust the viewport sticky but use the adjusted viewpoint middle point as the offset.
                        applyViewportSticky(stickyElement, viewportMiddlePoint, 'persistent');

                        // Trigger the stickyEnabled bool.
                        stickyEnabled = true;

                        // Reset our anchor point so we know where to hide it on scroll up.
                        anchorPoint = Math.round(anchorIn + (stickyHalfHeight));
                    }
                }
            }); 

            

            /////
            // Step 3: On page scroll adjust tigger the sticky element if dragged below the anchor in point, or drop the sticky if it's scrolled back belwo the anchor out point.
            /////

            var anchorIn = Math.round(stickyElement.offset().top - documentTopPoint + (stickyHalfHeight));
            // var anchorPoint = Math.round(stickyElement.offset().top) / 2;
            // it is, so on window scroll let's trigger the event...
            $(window).scroll(function() {

                // first up, let's check to see if the element is visible before we continue...
                if(isVisible(stickyElement)){    

                    // As the page scroll, let's update the document top point for any changes.
                    documentTopPoint = $(document).scrollTop();

                    var anchorIn = Math.round(stickyElement.offset().top - documentTopPoint + (stickyHalfHeight));


                    // -- Apply folded class

                    // As we scroll check to see if the sticky element is in the viewport, if it is let's apply the folded class.
                    if((stickyPosition + stickyHeight) < (viewportHeight + documentTopPoint)){
                        applyFoldedMenu(stickyElement, 'folded');
                    }
                    


                    // ----
                    // Now for the sticky...
                    // ------

                    // In bound: ----
                    // Check to see if stickyEnabled is set, this reduces down the productivity as it will only run if sticky is disabled.
                    if(!stickyEnabled){

                        // As the postion of the sticky element reaches (and passes) the centre of the viewport height, apply the sticky to retian it's position.
                        if(anchorIn <= viewportMiddlePoint){

                            // IF the sticky class isn't set then continue (precautionary check, it should always be false at this point).
                            if(!stickyElement.hasClass('persistent')){

                                // Apply the sticky, setting the offset as the anchor point.
                                applyViewportSticky(stickyElement, anchorIn, 'persistent');  
                            }

                            // Trigger the stickyEnabled bool.
                            stickyEnabled = true;

                            var contactPoint = stickyElement.offset().top;
                            anchorPoint = Math.round(anchorIn + (stickyHalfHeight));                            

                        }
                    }else{


                        // Out bound:  ----
                        // If the document top point is less than our anchor point we know sticky is active so let's step in...
                        if(documentTopPoint < anchorPoint){

                            // Calculate the position of the element by taking of the height of the viewport height.
                            var anchorOut = ((stickyElement.offset().top + stickyHeight) - (documentTopPoint - stickyHalfHeight)); 

                            // Is the sticky class set? If it is let's drop the sticky functionality.
                            if(stickyElement.hasClass('persistent')){
                                 dropViewportSticky(stickyElement, 'persistent');   
                            }

                            // Reset the stickyEnabled back to false for re-triggering.
                            stickyEnabled = false;

                            // Reset our anchor point back to zero for re-calculating.
                            anchorPoint = 0;
                        }
                    }


                    // The anchor point might get lost and lose it's righteous placement, if it does let's bring it back to the window by restting it to the viewport middle poiont.
                    if(anchorPoint < anchorIn || anchorPoint > viewportHeight){
                        anchorPoint = anchorIn;
                    }

                }
            });
        }

    },



    // -- Init app activity.
    init = function () {
        persistantStickyWhenVisible();
    };

    return {
        init: init
    }    	

}( jQuery, this ));

jQuery(app.quicklinks.init);

 